import { Component } from "preact";
import { isNullOrUndefined } from "util";
import { isNumber, numberWithCommas } from "../../../../utils/utility";
import { preventDefault } from "../../../../utils/common";
import { logEvent } from "../../../../utils/logger";
import SpinnerAmount from "../../async/spinner-amount";
import style from "./style";
import { locale } from "../../../../utils/i18n";

export default class QuantityAmount extends Component {
  constructor(props) {
    super(props);
    this.state = { isError: false, errorName: "", showAddButon: true, inputValue: "" };
    this.perUnitValue = props.constraints.value ? Number(props.constraints.value) : 0;
    this.startValue = props.constraints.minValue ? props.constraints.minValue : 1;
    // Start counter value always from 1
    this.counterStartValue =
      props.constraints.minValue && props.constraints.minValue !== "0" ? props.constraints.minValue : 1;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      this.setState({ isError: nextProps.isError, errorName: nextProps.errorName });
    }
  }

  validateNumberInput = event => {
    if (!isNumber(event)) {
      preventDefault(event);
    }
  };

  updateValue = quantity => {
    this.props.updateFormValue(this.props.index, quantity);
    this.props.updateAmount(this.perUnitValue * quantity);
  };

  clearErrors = () => {
    if (this.state.isError && !isNullOrUndefined(this.props.index)) {
      this.props.clearErrorData(this.props.index);
    }
    logEvent({ eventType: "clicked_form_field", eventValue: "amount form field", fieldName: this.props.name });
  };

  hideButton = () => {
    this.setState({ showAddButon: false });
    this.clearErrors();
    this.setQuantity(this.counterStartValue);
    logEvent({ eventType: "clicked_add_button", eventValue: "amount add button", fieldName: this.props.name });
  };

  showAddButton = () => {
    this.setState({ showAddButon: true });
    this.clearErrors();
    this.setQuantity("");
    logEvent({ eventType: "clicked_remove_button", eventValue: "amount remove button", fieldName: this.props.name });
  };

  setQuantity = count => {
    this.props.updateAmount(-(this.perUnitValue * this.state.inputValue));
    this.setState({ inputValue: count });
    this.updateValue(this.state.inputValue);
    this.state.isError ? this.clearErrors() : "";
  };

  render({ name, constraints, placeholder, subText }, { showAddButon }) {
    return (
      <div className={`${style["pos-r"]}`}>
        <div className={`${style.clear}`}>
          <div className={`${style["amt-label"]} ${style.ibl}`}>{placeholder}</div>
          <div className={`${style.quantity} ${style.ibl} ${style.tr}`}>
            <span className={`${style["rupee-sign"]}`}>&#x20b9;</span>
            {numberWithCommas(this.perUnitValue)} <span className={style.mult}>&#xD7;</span>
            {showAddButon && (
              <span className={`${style["link-btn"]}`} onClick={this.hideButton}>
                {locale("button.add")}
              </span>
            )}
            {!showAddButon && (
              <span>
                <SpinnerAmount
                  constraints={constraints}
                  setQuantity={this.setQuantity}
                  counterStartValue={this.counterStartValue}
                />
              </span>
            )}
            {!showAddButon && (
              <span className={`${style["link-btn"]}`} onClick={this.showAddButton}>
                {locale("button.remove")}
              </span>
            )}
          </div>
        </div>
        {subText && <p className={`input-info ${style.info}`}>{subText}</p>}
        {this.state.isError && (
          <span className={`error ${subText ? "sub-txt-err" : ""}`} data-error-for={name}>
            {this.state.errorName}
          </span>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./form/components/inputs/quantity-amount/index.js